export default __webpack_public_path__ + "static/media/Right-Photo-School@2x.6d2ddba3.jpg";